import React from 'react';
import { Grid } from '@mui/material';
import useShouldRender from './useShouldRender';
import useShouldDisable from './useShouldDisable';
import useIsMobile from '../../../../hooks/useIsMobile';

function ConfigInputWrapper({ formField, children, isEdit }) {
    const isMobile = useIsMobile();
    const { widths, mobileWidths, conditionalRender, conditionalCreateRender, conditionalEditRender, conditionalDisable } = formField;
    const gridWidths = isMobile && !!mobileWidths ? mobileWidths : widths;

    const shouldRenderCreateOption = !!conditionalCreateRender && !isEdit;
    const shouldRenderEditOption = !!conditionalEditRender && isEdit;
    let shouldRender = true;
    if (!!conditionalRender) {
        shouldRender = useShouldRender(conditionalRender, isEdit);
    } else if (shouldRenderCreateOption) {
        shouldRender = useShouldRender(conditionalCreateRender, isEdit);
    } else if (shouldRenderEditOption) {
        shouldRender = useShouldRender(conditionalEditRender, isEdit);
    }

    if (!shouldRender) return null;

    let shouldDisable = false;
    if (!!conditionalDisable) {
        shouldDisable = useShouldDisable(conditionalDisable);
    }

    const hidden = formField?.props?.type === 'hidden';
    // If field is supposed to be hidden, don't wrap it in a Grid
    // The Grid has a spacing associated with it, which will cause the field to be visible
    return hidden ? (
        children
    ) : (
        <Grid item xs={gridWidths?.xs || 12} sm={gridWidths?.sm || false} md={gridWidths?.md || false} lg={gridWidths?.lg || false}>
            {!!conditionalDisable
                ? React.cloneElement(children, {
                      ...children.props,
                      props: {
                          ...children.props.props,
                          disabled: shouldDisable,
                      },
                  })
                : children}
        </Grid>
    );
}

export default ConfigInputWrapper;
